
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useCallback } from "react";
import { BookOpen, Shield, Info, Search, MessageSquare, HandHeart } from "lucide-react";

const darkGray = "text-[#222222]";
const darkGrayHover = "hover:text-[#555]";
const navFont = "font-montserrat font-semibold";

// Returns "text-heaven-gold" if current path matches, otherwise default styling
function getNavHighlight(path: string, currentPath: string) {
  return path === currentPath ? "text-heaven-gold" : darkGray;
}

const NavItems = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;

  // For Apologetics desktop link navigation
  const handleApologeticsClick = useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    navigate("/apologetics", { replace: true });
  }, [navigate]);

  return (
    <nav className="flex items-center gap-6 justify-center">
      <Link
        to="/about"
        className={`${getNavHighlight("/about", currentPath)} ${darkGrayHover} px-4 text-sm ${navFont} transition-colors duration-150 flex items-center gap-2`}
      >
        <Info className="h-4 w-4 text-heaven-gold" />
        About
      </Link>
      <Link
        to="/find-your-verse"
        className={`${getNavHighlight("/find-your-verse", currentPath)} ${darkGrayHover} px-4 text-sm ${navFont} transition-colors duration-150 flex items-center gap-2`}
      >
        <Search className="h-5 w-5 text-heaven-gold" />
        Find Your Verse
      </Link>
      <Link
        to="/bible-tools"
        className={`${getNavHighlight("/bible-tools", currentPath)} ${darkGrayHover} px-4 text-sm ${navFont} transition-colors duration-150 flex items-center gap-2`}
      >
        <BookOpen className="h-5 w-5 text-heaven-gold" />
        Scripture Tools
      </Link>
      <a
        href="/apologetics"
        className={`${getNavHighlight("/apologetics", currentPath)} ${darkGrayHover} px-4 text-sm ${navFont} transition-colors duration-150 cursor-pointer flex items-center gap-2`}
        onClick={handleApologeticsClick}
      >
        <Shield className="h-4 w-4 text-heaven-gold" />
        Apologetics
      </a>
      <Link
        to="/prayer-generator"
        className={`${getNavHighlight("/prayer-generator", currentPath)} ${darkGrayHover} px-4 text-sm ${navFont} transition-colors duration-150 flex items-center gap-2`}
      >
        <MessageSquare className="h-4 w-4 text-heaven-gold" />
        Prayer
      </Link>
      <Link
        to="/ministry"
        className={`${getNavHighlight("/ministry", currentPath)} ${darkGrayHover} px-4 text-sm ${navFont} transition-colors duration-150 flex items-center gap-2`}
      >
        <HandHeart className="h-4 w-4 text-heaven-gold" />
        Ministry
      </Link>
    </nav>
  );
};

export default NavItems;

